import { Theme, IconButtonSize, IconButtonColor } from './theme';

export const getIconButtonStyles = (
	theme: Theme,
	size: IconButtonSize = 'medium',
	buttonColor: IconButtonColor = 'primary'
) => {
	const { width, height, padding } = theme.button.size[size];
	const { backgroundColor, color } = theme.button.color[buttonColor];
	const css = {
		iconButton_css: {
			width: width,
			height: height,
			padding: padding,
			backgroundColor: backgroundColor,
			color: color,
			boxShadow: theme.button.iconButtonShadow
		},
		iconButtonFocused_css: {
			border: theme.button.focused.border,
			boxShadow: theme.button.focused.boxShadow
		},
		destroyFocused_css: {
			boxShadow: theme.button.destroyFocused.boxShadow
		},
		circle_css: {
			borderRadius: theme.button.circle.borderRadius
		}
	};

	return css;
};
